function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "checkbox-unchecked");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "gray",
  d: "M15,17.9H0v-15H15ZM1.5,16.41h12v-12H1.5Z",
  transform: "translate(0 -2.94)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 14.96,
    height: 14.96,
    viewBox: "0 0 14.96 14.96"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/checkbox-unchecked.1af43eec.svg";
export { SvgComponent as ReactComponent };